import {
  dealAmount2Fiexd,
  dealAmount9Valid,
  dealAmountSegmentationAnd2Fixed,
  getCurrencyImagePath,
} from "@/Core/utils/currencyDealCenter";
import React from "react";
import { CurrencyCompoentProps, FormatAmountType } from "./interface";

import SpaceUI from "@/componentsUI/Space";
import { formatCurrencyType } from "@/features/common/currencyDisplay/CurrencyDisplay";
import { getCurrentCurrency } from "@/utils/countryConfigUtils";

const CurrencyComponent = (props: CurrencyCompoentProps) => {
  const {
    currencyType,
    serverCurrencyType,
    amount,
    showIcon = true,
    showUnit = true,
    type = "SegmentationAndFixed2",
    iconPosition = "lt",
    unitPosition = "lt",
    className,
    style,
    styleIcon,
  } = props;

  const dealAmount = (type: FormatAmountType, amount) => {
    if (amount === null || amount === undefined) return null;

    // 智能推断 serverCurrencyType：
    // 如果没有提供 serverCurrencyType，且 currencyType 是当前国家配置的本地货币，
    // 则默认使用 BRL 作为服务端货币类型（用于精度计算）
    let actualServerCurrencyType = serverCurrencyType;
    if (!actualServerCurrencyType && currencyType) {
      const localCurrency = getCurrentCurrency();
      // 加密货币列表（这些不需要转换）
      const cryptoCurrencies = ["USDT", "BTC", "ETH", "FUN"];
      
      // 如果当前货币是本地货币且不是加密货币，默认服务端使用 BRL
      if (currencyType === localCurrency && !cryptoCurrencies.includes(currencyType)) {
        actualServerCurrencyType = "BRL";
      }
    }

    const extra = { currencyType, serverCurrencyType: actualServerCurrencyType };

    switch (type) {
      case "raw":
        return amount;
      case "valid9":
        return dealAmount9Valid(amount, extra);
      case "fixed2":
        return dealAmount2Fiexd(amount, extra);
      case "SegmentationAndFixed2":
      default:
        return dealAmountSegmentationAnd2Fixed(amount, extra);
    }
  };

  const renderIcon = () =>
    showIcon && (
      <div className="icon" key="currency-icon">
        <img
          style={styleIcon}
          src={getCurrencyImagePath(currencyType)}
          alt={formatCurrencyType(currencyType)}
        />
      </div>
    );

  // 根据currencyType决定显示的货币单位文本
  const renderUnit = () => {
    if (!showUnit) return null;
    return (
      <div className="unit" key="currency-unit">
        {formatCurrencyType(currencyType)}
      </div>
    );
  };

  const renderAmount = () =>
    amount !== null &&
    amount !== undefined && (
      <div className="amount" key="currency-amount">
        {dealAmount(type, amount)}
      </div>
    );

  // 根据位置参数确定元素顺序
  const elements = [];

  // 按从左到右顺序排列元素
  const positions = ["lt", "center", "rt"]; // center 用于没有指定位置的 amount
  const elementsByPosition = {
    lt: [],
    center: [renderAmount()],
    rt: [],
  };

  // 将 icon 和 unit 放入对应位置
  iconPosition && elementsByPosition[iconPosition].push(renderIcon());
  unitPosition && elementsByPosition[unitPosition].push(renderUnit());

  // 按从左到右顺序整合所有元素并确保每个元素有唯一key
  let index = 0;
  positions.forEach((pos) => {
    elementsByPosition[pos].forEach((element) => {
      if (element && !element.key) {
        elements.push(
          React.cloneElement(element, { key: `currency-element-${index++}` })
        );
      } else {
        elements.push(element);
      }
    });
  });

  return (
    <SpaceUI
      direction="horizontal"
      className={["currency-compoent", className]}
      style={style}
    >
      {elements}
    </SpaceUI>
  );
};

export default CurrencyComponent;
